/**
 * Pure helpers for the workspace-setup flow's mode- and persona-dependent copy.
 */

import { REQUESTER_TYPE, type RequesterType } from "@/frontend/types/org";

/**
 * Copy that differs between the two modes. Signup is creating the workspace;
 * backfill is recording details on one the owner already has, so neither the
 * heading nor the button may imply creation. `heading` and `submit` belong to
 * step two; `submitting` labels the primary on both steps.
 */
export function workspaceSetupCopy(isBackfill: boolean) {
  return isBackfill
    ? {
        heading: "Your workspace details",
        submit: "Save",
        submitting: "Saving...",
      }
    : {
        heading: "Set up your workspace",
        submit: "Create workspace",
        submitting: "Setting up...",
      };
}

/** Heading above the address fields, naming whose address is wanted. */
export function requesterAddressHeading(requesterType: RequesterType): string {
  return requesterType === REQUESTER_TYPE.PERSON ? "Your address" : "Organization address";
}
